
// export const myGetter = ( state ) => {
//  return state
// }

export const classificationsList = state => state.classifications
export const classificationsSelectable = state => state.classificationsSelectable
export const classificationsPaginatedData = state => state.classificationsPaginatedData
export const classification = state => state.classification
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData